/** @format */

import * as actionTypes from "../types";

const initialState = {
    cartProductsQuantity:0,
};

const cartProductsQuantity = (state = initialState, action) => {  
  switch (action.type) {
    case actionTypes.SET_CART_PRODUCTS_QUANTITY:
    console.log("testing::inside reducer, action--",action);
      return {
        ...state,
        cartProductsQuantity: action.payload.cartProductsQuantity || 0,
      };

    default:
      return state;
  }
};
export default cartProductsQuantity;
